import { useRef, useState } from 'react';

interface StepperPageShellProps {
  title: React.ReactNode;
  stepper: React.ReactNode;
  children: React.ReactNode;
  footer: React.ReactNode;
  as?: 'div' | 'form';
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  headerClassName?: string;
  footerClassName?: string;
}

const StepperPageShell: React.FC<StepperPageShellProps> = ({
  title,
  stepper,
  children,
  footer,
  as = 'div',
  onSubmit,
  headerClassName = 'gap-5',
  footerClassName = '',
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const shellContent = (
    <>
      <div
        className={`pt-2.5 flex flex-col ${headerClassName}`}
        style={
          isScrolled
            ? {
                boxShadow:
                  '0 1px 3px 0 rgba(0,0,0,0.15), 0 4px 8px 3px rgba(0,0,0,0.08)',
                clipPath: 'inset(0 0 -20px 0)',
              }
            : undefined
        }
      >
        <p className="text-titleLarge text-neutral-10">{title}</p>
        {stepper}
      </div>

      <div
        ref={scrollRef}
        onScroll={() => setIsScrolled((scrollRef.current?.scrollTop ?? 0) > 0)}
        className="flex flex-col gap-8 overflow-auto custom-scrollbar pb-[120px] px-4 -mx-4 flex-1 min-h-0"
      >
        {children}

        <div
          className={`flex fixed bottom-10 max-h-[64px] justify-between gap-[16px] bg-[#FAFAFA] rounded-[20px] px-3 py-3 z-10 ${footerClassName}`.trim()}
          style={{
            left: 'calc(var(--sidebar-width) + 30px)',
            right: '30px',
            boxShadow:
              '0px 2px 8px 0px #00000014, 0px 6px 12px 4px #0000000A, 0px -2px 8px 0px #00000014',
          }}
        >
          {footer}
        </div>
      </div>
    </>
  );

  return (
    <div className="relative w-full h-full">
      {as === 'form' ? (
        <form
          onSubmit={onSubmit}
          className="bg-white w-full h-full px-4 pt-4 flex flex-col overflow-hidden rounded-[4px] shadow-[0px_2px_4px_0px_#00000014]"
        >
          {shellContent}
        </form>
      ) : (
        <div className="bg-white w-full h-full px-4 pt-4 flex flex-col overflow-hidden rounded-[4px] shadow-[0px_2px_4px_0px_#00000014]">
          {shellContent}
        </div>
      )}
    </div>
  );
};

export default StepperPageShell;
